import { render, staticRenderFns } from "./WorksheetChooser.vue?vue&type=template&id=638ebf04&"
import script from "./WorksheetChooser.vue?vue&type=script&lang=js&"
export * from "./WorksheetChooser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports